import { Component, OnDestroy } from '@angular/core';
import { CnafContacterMaCafService } from '../services/contactermacaf.service';
import { CnafUserService, CnafAtTagService } from '@cnaf/ng-cnaf-commons';
import { ContacterMaCafCompletSharedComponent } from './contactermacafcomplet.shared.component';
import { Router } from '@angular/router';
import { BsModalService } from 'ngx-bootstrap/modal';
import { InformationsSvi} from '../models/svi.model';
import { TagXitiService } from '../services/tagxiti.service';
import { Subscription } from 'rxjs';
import {context} from '../../contexts/context';

@Component({
  selector: 'cnaf-contactermacaf-complet-mobile',
  templateUrl: './contactermacafcomplet.component-mobile.html',
  styleUrls: ['./contactermacafcomplet.component.css', './contactermacafcomplet.component-mobile.css']
})
export class ContacterMaCafCompletMobileComponent extends ContacterMaCafCompletSharedComponent implements OnDestroy {
  usagerAutoriseSviVisuel = false;
  disponibiliteFileSviVisuel = false;
  etudiant = false;
  accesMotifsDeContact = false;
  codeOrga!: string;
  delaiAttenteChargeeSub$!: Subscription;
  constructor(
    _cnafContacterMaCafService: CnafContacterMaCafService,
    cnafUserService: CnafUserService,
    _modalService: BsModalService,
    _cnafAtTagService: CnafAtTagService,
    _router: Router,
    _tagXitiService: TagXitiService,
    ) {
    super('mobile', _cnafContacterMaCafService, cnafUserService, _modalService, _cnafAtTagService, _router, _tagXitiService);
  }

  ngOnDestroy(): void {
    this.delaiAttenteChargeeSub$?.unsubscribe();
  }

  onInit(): void {
     // Pour le mobile , on verifie si le svi est disponible pour l'usager
     this.codeOrga = this.cnafUserService.codeOrga;
    this.cnafContacterMaCafService.getSviInformations().subscribe((informationSvi: InformationsSvi) => {
      if (informationSvi) {
        this.usagerAutoriseSviVisuel = informationSvi.usagerAutoriseSviVisuel;
        this.disponibiliteFileSviVisuel = informationSvi.disponibiliteFileSviVisuel;
        this.etudiant = informationSvi.parcoursEtudiant;
        this.accesMotifsDeContact = informationSvi.accesMotifsDeContact;
      }
    });
    this.delaiAttenteChargeeSub$ = this.cnafContacterMaCafService.delaiAttenteChargee.subscribe({
      next: (data: any) => {
        if(data.chargementTermine)
         this.etat =  'loaded';
      }
    });
  }

  appellerCaf(event: any) {
    this.etat = 'loading';
    if (!this.accesMotifsDeContact) {
      //tag bouton appeler ma caf (1)
      const tagObj = this.tagXitiService.getAtTagObject('appeler_ma_caf', context.type, 'contactermacaf',
        'svi_visuel', 'bouton');
      this.cnafAtTagService.pageSend(tagObj);
      this.cnafContacterMaCafService.appeldelaiAttente(false,undefined);
    }
    else {
      //tag bouton appeler ma caf (1)
      const tagObj = this.tagXitiService.getAtTagObject('appeler_ma_caf', context.type, 'contactermacaf',
        'svi_visuel', 'bouton');
      this.cnafAtTagService.pageSend(tagObj);
      this.router.navigate(["/motifsdecontact"]);
    }
  }
}
